import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Committee } from './committee.model';
import committeeService from './committee.service';

// namespace
export const COMMITTEE_STORE_NAMESPACE = 'committeeStore';

// state
interface CommitteeState {
  committees: Committee[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: CommitteeState = {
  committees: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<CommitteeState> = {
  [mutationConstant.FETCH]: (state: CommitteeState, committees: Committee[]) => {
    state.committees = committees;
  },
  [mutationConstant.PENDING]: (state: CommitteeState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: CommitteeState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: CommitteeState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
};

const action: ActionTree<CommitteeState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<CommitteeState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      committeeService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<CommitteeState, RootState> = {
  [getterConstant.ALL]: (state: CommitteeState) => state.committees,
  [getterConstant.BY_ID]: (state: CommitteeState) => (id: number) => state.committees.find(m => m.id === id),
  [getterConstant.STATUS]: (state: CommitteeState) => state.status,
};

// module
const module: Module<CommitteeState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const CommitteeGetter = {
  ALL: `${COMMITTEE_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${COMMITTEE_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${COMMITTEE_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const CommitteeAction = {
  FETCH: `${COMMITTEE_STORE_NAMESPACE}/${actionConstant.FETCH}`,
};

export default module;
